var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8984 0C33.4968 0 42.8984 9.4016 42.8984 21C42.8984 32.5984 33.4968 42 21.8984 42C10.3 42 0.898438 32.5984 0.898438 21C0.898438 9.4016 10.3 0 21.8984 0Z",
    fill: "url(#paint0_linear_1737_4230)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7297 13.0742C20.1069 13.0742 23.6556 16.6229 23.6556 21.0001C23.6556 25.3773 20.1069 28.9259 15.7297 28.9259C11.3534 28.9259 7.80469 25.3773 7.80469 21.0001C7.80469 16.6229 11.3534 13.0742 15.7297 13.0742ZM34.5953 14.326C35.3672 14.326 35.9923 17.3144 35.9923 21.0001C35.9923 24.6857 35.3672 27.6741 34.5953 27.6741C33.8242 27.6741 33.1983 24.6857 33.1983 21.0001C33.1983 17.3144 33.8242 14.326 34.5953 14.326ZM28.4118 13.7001C30.6266 13.7001 32.4214 16.9682 32.4214 21.0001C32.4214 25.0319 30.6266 28.3 28.4118 28.3C26.1969 28.3 24.4013 25.0319 24.4013 21.0001C24.4013 16.9682 26.1969 13.7001 28.4118 13.7001Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1737_4230",
    x1: 6.46262,
    y1: 6.76102,
    x2: 39.7968,
    y2: 31.9905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E1B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#474747"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.3a601309041de41f24700ae7f934618d.svg";
export { ForwardRef as ReactComponent };